<template>
  <div class="tinymce-box">
    <editor
      v-model="myValue"
      :key="tinymceFlag"
      :init="init"
      :disabled="disabled"
      @onClick="onClick"
    ></editor>
  </div>
</template>

<script>
import commonApi from "@/api/common/common";
import videoApi from "@/api/web/videoArticle";
import attachApi from "@/api/web/attachment";
import tinymce from "tinymce/tinymce"; //tinymce默认hidden，不引入不显示
import Editor from "@tinymce/tinymce-vue";
import "tinymce/themes/silver";
import "tinymce/icons/default/icons";
// 编辑器插件plugins
// 更多插件参考：https://www.tiny.cloud/docs/plugins/
import "tinymce/plugins/image"; // 插入上传图片插件
import "tinymce/plugins/media"; // 插入视频插件
import "tinymce/plugins/table"; // 插入表格插件
import "tinymce/plugins/lists"; // 列表插件
import "tinymce/plugins/link"; // 超链接插件
import "tinymce/plugins/wordcount"; // 字数统计插件
import "tinymce/plugins/fullscreen"; // 全屏插件
import "tinymce/plugins/code"; //查看源代码
import "tinymce/plugins/preview"; //查看源代码
import "./plugins/indent2em"; //首行缩进
export default {
  components: {
    Editor,
  },
  // name: "tinymce",
  props: {
    value: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    plugins: {
      type: [String, Array],
      default:
        "fullscreen lists media table link image wordcount indent2em code preview",
    },
    toolbar: {
      type: [String, Array],
      default: () => [
        // media preview
        "fullscreen | undo redo | image media lists table | lineheight fontselect fontsizeselect bold italic forecolor backcolor removeformat link | formatselect",
        "alignleft aligncenter alignright alignjustify | bullist numlist indent2em outdent indent | code",
      ],
    },
    contentStyle: {
      type: String,
      default:
        "body {margin:1rem 2rem} p {margin:0;line-height: 1.75;font-family: simsun, serif;font-size:16px;color:#000000;} img{max-width:100%;max-height:100%;margin:0 auto;}",
    },
    height: {
      type: Number,
      default: 300,
    },
  },
  data() {
    return {
      tinymceFlag: 1,
      init: {
        content_css: "./tinymce/skins/content/default/content.css",
        language_url: "./tinymce/langs/zh_CN.js",
        language: "zh_CN",
        skin_url: "./tinymce/skins/ui/oxide",
        // skin_url: 'tinymce/skins/ui/oxide-dark',//暗色系
        height: this.height,
        plugins: this.plugins,
        toolbar: this.toolbar,
        branding: false, //隐藏技术支持字样
        convert_urls: false,
        contextmenu: false, //右键菜单
        // contextmenu_never_use_native:true, //禁用浏览器右键
        draggable_modal: false, //可拖动大小
        // elementpath:false,//显示底部元素路径
        menubar: false, //顶部菜单
        // resize:false, //可拖动大小
        // statusbar:false,//底部状态栏
        toolbar_drawer: "sliding",
        lineheight_formats: "1 1.3 1.5 1.6 1.75 1.8 2 2.5 3 4 5", //行高参数
        fontsize_formats:
          "12px 13px 14px 15px 16px 17px 18px 19px 20px 22px 24px 36px 48px", //字体大小参数
        //字体配置
        font_formats:
          "微软雅黑=Microsoft YaHei,Helvetica Neue,PingFang SC,sans-serif;" +
          "宋体=simsun,serif;" +
          "楷体=KaiTi,sans-serif;" +
          "仿宋体=FangSong,serif;" +
          "黑体=SimHei,sans-serif;" +
          "Andale Mono=andale mono,times;" +
          "Arial=arial,helvetica,sans-serif;" +
          "Arial Black=arial black,avant garde;",
        inline_boundaries: false, //内置样式开关
        content_style: this.contentStyle,
        // 此处为图片上传处理函数，这个直接用了base64的图片形式上传图片，
        // 如需ajax上传可参考https://www.tiny.cloud/docs/configure/file-image-upload/#images_upload_handler
        images_upload_handler: (blobInfo, success, failure) => {
          // const img = "data:image/jpeg;base64," + blobInfo.base64();
          // success(img);
          let data = new FormData();

          // var config = this.$store.state.user.fileConfig;
          var limit = 5;
          //console.log("limit", limit);
          //console.log("size", file.size, file.size / 1024 / 1024);
          if (blobInfo.blob().size / 1024 / 1024 > limit) {
            console.log("limit", limit);
            //this.$message.warning("图片大小不能大于" + limit + "MB");
            failure("图片大小不能大于" + limit + "MB");
            //return false;
          } else {
            data.append("file", blobInfo.blob(), blobInfo.filename());
            data.append("type", "editor");
            commonApi.uploadPicture(data).then((res) => {
              let url =
                document.location.protocol +
                "//" +
                document.location.host +
                "/api" +
                res.Data;
              success(url);
            });
          }
        },
        file_picker_types: "file media image",
        media_live_embeds: true,
        file_picker_callback: (callback, value, meta) => {
          // console.log("picker", value, meta);
          // var config = this.$store.state.user.fileConfig;
          if (meta.filetype == "media") {
            var limit = 50;

            let input = document.createElement("input"); //创建一个隐藏的input
            input.setAttribute("type", "file");
            input.setAttribute("accept", "video/*");
            let _this = this;
            input.onchange = function () {
              let file = this.files[0]; //选取第一个文件
              // console.log("file", file);
              // console.log("limit", limit);

              if (file.size / 1024 / 1024 > limit) {
                _this.$message({
                  type: "warning",
                  message: "视频大小不能大于" + limit + "MB",
                  duration: 3000,
                  customClass: "message-override",
                });
              } else {
                let data = new FormData();
                data.append("file", file);
                data.append("token", _this.$commonJs.getCookie("token"));

                commonApi.uploadMp4(data).then((res) => {
                  console.log("上传视频文件", res);
                  if (res.Code == 0) {
                      let url =
                document.location.protocol +
                "//" +
                document.location.host +
                "/api" +
                res.Data;
                    callback(url, { title: file.name });
                  } else {
                    _this.$message.error(res.Msg);
                  }
                });
              }
            };
            //触发点击
            input.click();
          }
          if (meta.filetype == "file") {
            console.log("file");
            var limit = 2;

            let input = document.createElement("input"); //创建一个隐藏的input
            input.setAttribute("type", "file");
            // input.setAttribute("accept", "video/*");
            let _this = this;
            input.onchange = function () {
              let file = this.files[0]; //选取第一个文件
              console.log("file", file);
              console.log("limit", limit);

              if (file.size / 1024 / 1024 > limit) {
                _this.$message({
                  type: "warning",
                  message: "附件大小不能大于" + limit + "MB",
                  duration: 3000,
                  customClass: "message-override",
                });
              } else {
                let data = new FormData();
                data.append("file", file);
                data.append("token", _this.$commonJs.getCookie("token"));

                attachApi.uploadFile(data).then((res) => {
                  console.log("上传附件", res);
                  if (res.Code == 0) {
                    callback("/api" + res.Data.FileUrl, {
                      // title: file.name,
                      text: file.name,
                    });
                  } else {
                    _this.$message.error(res.Msg);
                  }
                });
              }
            };
            //触发点击
            input.click();
          }
          if (meta.filetype == "image") {
            let input = document.createElement("input"); //创建一个隐藏的input
            input.setAttribute("type", "file");
            input.setAttribute("accept", "image/*");
            let _this = this;
            var limit = 4;
            input.onchange = function () {
              let file = this.files[0]; //选取第一个文件
              if (file.size / 1024 / 1024 > limit) {
                _this.$message({
                  type: "warning",
                  message: "图片大小不能大于" + limit + "MB",
                  duration: 3000,
                  customClass: "message-override",
                });
              } else {
                let data = new FormData();
                data.append("file", file);
                data.append("dic", "content");
                data.append("token", localStorage.getItem("token"));

                commonApi.uploadPicture(data).then((res) => {
                  console.log("上传图片", res);
                  if (res.Code == 0) {
                    let url =
                      document.location.protocol +
                      "//" +
                      document.location.host +
                      "/api" +
                      res.Data;
                    callback(url, {
                      text: file.name,
                      width: "100%",
                      height: "100%",
                    });
                  } else {
                    _this.$message.error(res.Msg);
                  }
                });
              }
            };
            //触发点击
            input.click();
          }
        },
      },
      myValue: this.value,
    };
  },
  mounted() {
    // alert("123")
    tinymce.init({});
  },
  activated() {
    //解决多页面缓存下富文本框失效的问题
    this.tinymceFlag++;
  },
  methods: {
    // 添加相关的事件，可用的事件参照文档=> https://github.com/tinymce/tinymce-vue => All available events
    // 需要什么事件可以自己增加
    onClick(e) {
      this.$emit("onClick", e, tinymce);
    },
    // 可以添加一些自己的自定义事件，如清空内容
    clear() {
      this.myValue = "";
    },
    //获取纯文本
    getPlainText(more = null) {
      if (more == null) {
        //如果当前页面只有一个编辑器
        return tinymce.activeEditor.getContent({ format: "text" });
      } else {
        //如果当前页面有多个编辑器（填“[0]”表示第一个编辑器，以此类推）
        return tinyMCE.editors[more].getContent({ format: "text" });
      }
    },
  },
  watch: {
    value(newValue) {
      this.myValue = newValue;
    },
    myValue(newValue) {
      this.$emit("input", newValue);
    },
  },
};
</script>
<style>
.tox-fullscreen .tox.tox-tinymce-aux,
.tox.tox-silver-sink.tox-tinymce-aux {
  z-index: 3001 !important;
}
.message-override {
  z-index: 99999 !important;
}
</style>